module.exports = __webpack_public_path__ + "WorkSans-Regular.740b8e9adcb998d4f65b.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Regular.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Regular.ttf
// module chunks = styles